import React from "react";
import { useState } from "react";
import { Grid, Header, Container } from "semantic-ui-react";
import CheckboxTree from "./CheckboxTree";
import DataViewer from "./DataViewer";
import AcronymsSidebar from "./AcronymsSidebar";

const HierarchicalDataViewer = ({
  hierarchyData,
  mergedData,
  ontologyDictionary,
  understandableLabelsDictionary,
  acronymsData,
}) => {
  const [selectedColumns, setSelectedColumns] = useState([]);

  return (
    <Container className="hierarchical-data-viewer" fluid>
      <Grid>
        <Grid.Column width={4}>
          <Header as="h2">Column Selection</Header>
          <CheckboxTree
            data={hierarchyData}
            selectedColumns={selectedColumns}
            setSelectedColumns={setSelectedColumns}
            ontologyDictionary={ontologyDictionary}
          />
        </Grid.Column>
        <Grid.Column width={12}>
          <DataViewer
            data={mergedData}
            selectedColumns={selectedColumns}
            ontologyDictionary={ontologyDictionary}
            understandableLabelsDictionary={understandableLabelsDictionary}
            acronymsData={acronymsData} // Pass acronymsData to DataViewer
          />
        </Grid.Column>
      </Grid>
    </Container>
  );
};

export default HierarchicalDataViewer;
